import fetchAPI from '../fetchAPI';

export interface CreateMarkupPayload {
  type: string;
  title: string;
  muvalue: number;
  price?: number;
  description?: string;
  // AI purpose
  responseModel?: string;
  responseMuValue?: number;
  responseInputPrice?: number;
  responseOutputPrice?: number;
  // SR-H6: per-enquiry-type override for responseMuValue. Response-only.
  responseMuValueSales?: number | null;
  responseMuValueLettings?: number | null;
  // Sentiment purpose
  sentimentModel?: string;
  sentimentMuValue?: number;
  sentimentInputPrice?: number;
  sentimentOutputPrice?: number;
  // Enquiries purpose
  enquiriesModel?: string;
  enquiriesMuValue?: number;
  enquiriesInputPrice?: number;
  enquiriesOutputPrice?: number;
}

export const callCreateMarkup = async (data: CreateMarkupPayload): Promise<iResponse<MarkUp>> => {
  const response: iResponse<MarkUp> = await fetchAPI({
    method: 'POST',
    route: 'markup',
    data
  });
  return response;
};

export default callCreateMarkup;
